import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
})

export const FormProveedorContacto = ({formData = null, handleSubmit, handleCancel}) => {

    const classes = useStyles();

    const [formValues, handleInputChange] = useForm(formData || {idTipoContacto: "", nombreApellido:"", mail:"", cargo:"", direccion:"", telefono:"",celular:"", observaciones:""})

    const onSumbit = (e) => {
        e.preventDefault()
        handleSubmit(formValues)
    }

    return (
        <ValidatorForm onSubmit={onSumbit}>
            <Grid container style={{padding: 25}}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Tipo Contacto"
                        name="idTipoContacto"
                        value={formValues.idTipoContacto}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El tipo es requerido"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Nombre y Apellido"
                        name="nombreApellido"
                        value={formValues.nombreApellido}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El nombre y apellido es requerido"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Mail"
                        name="mail"
                        value={formValues.mail}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El mail es requerido"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Cargo"
                        name="cargo"
                        value={formValues.cargo}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Dirección"
                        name="direccion"
                        value={formValues.direccion}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Telefono"
                        name="telefono"
                        value={formValues.telefono}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Celular"
                        name="celular"
                        value={formValues.celular}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Observaciones"
                        name="observaciones"
                        value={formValues.observaciones}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                    />
                </Grid>
            </Grid> 

            <Grid container className={classes.botonera} >
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<CancelIcon />}
                            onClick={handleCancel}

                        >
                            CANCELAR
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<SaveIcon />}
                            type='submit'
                            style={{ marginLeft: "0.5rem" }}
                        >
                            GUARDAR
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

        </ValidatorForm>
    );
};

